<div class="collapse-panel-list">
  <div class="collapse-panel-item" *ngFor="let panel of panels; let i = index; let last = last">
    <button class="collapse-panel-header" (click)="togglePanel(i)">
      <span [class]="leftIconClass"></span>
      <span class="panel-title">
        {{ panel.title }}
      </span>
      <span class="material-icons toggle-icon">
        {{ isPanelOpen(i) ? 'expand_less' : 'expand_more' }}
      </span>
    </button>
    <div class="collapse-panel-content" *ngIf="isPanelOpen(i)">
      <div class="panel-content-text" *ngIf="panel.content">
        {{ panel.content }}
      </div>
    </div>
    <div class="panel-divider" *ngIf="!last"></div>
  </div>
</div>
